// ---------------------------------------------------------------------------
// Smart Forms — form_definitions + form_field_analytics (V2 Doc 44)
// ---------------------------------------------------------------------------
// form_submissions already exists in page-builder-supporting.ts

import { pgTable, uuid, text, varchar, integer, decimal, jsonb, timestamp, boolean, index } from "drizzle-orm/pg-core";

const tz = { withTimezone: true } as const;

export const formDefinitions = pgTable(
  "form_definitions",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    name: text("name").notNull(),
    slug: text("slug"),
    status: varchar("status", { length: 20 }).notNull().default("draft"), // draft | published | archived
    mode: varchar("mode", { length: 20 }).notNull().default("classic"), // conversational | classic | both
    fields: jsonb("fields").notNull().default([]),
    logic: jsonb("logic").notNull().default([]),
    scoring: jsonb("scoring").notNull().default({}),
    crmMapping: jsonb("crm_mapping").notNull().default({}),
    onSubmitActions: jsonb("on_submit_actions").notNull().default([]),
    settings: jsonb("settings").notNull().default({}),
    thankYouConfig: jsonb("thank_you_config").notNull().default({}),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_form_defs_tenant").on(table.tenantId),
    index("idx_form_defs_status").on(table.tenantId, table.status),
  ],
);

export const formFieldAnalytics = pgTable(
  "form_field_analytics",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    tenantId: uuid("tenant_id").notNull(),
    formId: uuid("form_id").notNull(),
    fieldId: text("field_id").notNull(),
    period: timestamp("period", tz).notNull(), // date bucket
    views: integer("views").notNull().default(0),
    starts: integer("starts").notNull().default(0),
    completions: integer("completions").notNull().default(0),
    avgDuration: decimal("avg_duration"), // seconds
    dropOffRate: decimal("drop_off_rate"),
    createdAt: timestamp("created_at", tz).notNull().defaultNow(),
  },
  (table) => [
    index("idx_form_field_analytics_form").on(table.tenantId, table.formId, table.period),
  ],
);
